import React from 'react'
import c from './img/asterisk.png'
///import cc from './img/down.png'
import { Container   } from 'react-bootstrap';
import LightSpeed from 'react-reveal/LightSpeed';

export const Permitforuseexceeds = () => (

<Container>


 <div style={styles.container}>
      <LightSpeed right>
        <div style={styles.card}>
          
          {/* כותרת הסבר */}
          <p style={styles.introText}>
            על פי הנחיות היועץ המשפטי לממשלה בנוגע לרישוי עסקים במבנים שאינם מוסדרים, 
            המחלקה לתכנון ולרישוי הנדסי בודקת את התאמת הבקשה לדיני התכנון והבנייה בנושאים הבאים:
          </p>

          {/* רשימת בדיקות מעוצבת */}
          <div style={styles.listContainer}>
            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>חוקיות המבנה והיתר הבנייה.</p>
            </div>

            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>
                במידה ואין היתר בנייה - נבדקת מידת העמידה בהגדרות המאפשרות קבלת רישיון עסק ללא היתר.
              </p>
            </div>

            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>
                התאמת השימוש בנכס לייעוד המבנה על פי היתר הבנייה ותוכנית בניין עיר (תב"ע).
              </p>
            </div>
          </div>

          <p style={styles.secondaryText}>
            בדיקה זו מתבצעת במידה והשימוש המבוקש אינו תואם את היתר הבנייה או התב"ע הקיימת.
          </p>



{/* כותרת והסבר */}
<div style={styles.articleSection}>

  <h2 style={styles.articleTitle}>
    רישוי עסקים במבנים לא מוסדרים
  </h2>

  <p style={styles.articleIntro}>
    דיני תכנון ובנייה והנחיות היועמ"ש
  </p>

  <p style={styles.articleText}>
    פתיחת עסק או חידוש רישיון במבנה שאינו מוסדר מבחינה תכנונית
    מציבים אתגר משפטי ומנהלי מורכב. כדי להסדיר סוגיה זו, קבע
    היועץ המשפטי לממשלה הנחיות ברורות המגדירות כיצד תבחן
    המחלקה לתכנון ולרישוי הנדסי את התאמת בקשת הרישוי
    לחוק התכנון והבנייה.
  </p>

  <p style={styles.articleText}>
    מטרת הבדיקה היא למנוע מצב שבו רישיון העסק יכשיר בעקיפין
    עבירות בנייה חמורות, תוך מתן פתרונות מוגדרים לעסקים
    הפועלים במבנים מורכבים.
  </p>


  {/* שלושת צירי הבדיקה */}
  <div style={styles.articleBlock}>

    <h3 style={styles.articleSectionTitle}>
      שלושת צירי הבדיקה של מחלקת ההנדסה
    </h3>

    <div style={styles.articleCards}>

      {/* 1 */}
      <div style={styles.articleCard}>

        <div style={styles.articleCardNumber}>
          01
        </div>

        <div>
          <h4 style={styles.articleCardTitle}>
            חוקיות המבנה והיתר הבנייה
          </h4>

          <p style={styles.articleCardText}>
            המחלקה בוחנת האם המבנה הפיזי שבו מתוכנן לפעול העסק
            הוקם כחוק והאם קיים עבורו היתר בנייה תקף ומלא
            במערכות הרשות.
          </p>
        </div>

      </div>


      {/* 2 */}
      <div style={styles.articleCard}>

        <div style={styles.articleCardNumber}>
          02
        </div>

        <div>
          <h4 style={styles.articleCardTitle}>
            מבנים ללא היתר בנייה
          </h4>

          <p style={styles.articleCardText}>
            במידה ונמצא כי למבנה אין היתר בנייה מוסדר, נערכת
            בדיקה של מידת העמידה בקריטריונים ובהגדרות המשפטיות
            המיוחדות המאפשרות, במקרים חריגים בלבד, קבלת
            רישיון עסק ללא קיומו של היתר.
          </p>
        </div>

      </div>


      {/* 3 */}
      <div style={styles.articleCard}>

        <div style={styles.articleCardNumber}>
          03
        </div>

        <div>
          <h4 style={styles.articleCardTitle}>
            התאמת השימוש לייעוד המבנה
          </h4>

          <p style={styles.articleCardText}>
            מתבצעת בדיקה של ההלימה בין סוג הפעילות של העסק לבין
            הייעוד המקורי של המבנה כפי שנקבע בהיתר הבנייה
            ובתוכנית בניין עיר (תב"ע).
          </p>

          <div style={styles.exampleBox}>
            <strong>
              לדוגמה:
            </strong>
            {' '}
            הפעלת חנות מסחר במבנה המוגדר למגורים או לתעשייה.
          </div>
        </div>

      </div>

    </div>

  </div>


  {/* שימוש חורג */}
  <div style={styles.warningBox}>

    <div style={styles.warningIcon}>
      ⚠
    </div>

    <div>

      <h3 style={styles.warningTitle}>
        חובת בעל העסק: היתר לשימוש חורג ותיקון 101
      </h3>

      <p style={styles.warningText}>
        במקרים שבהם נמצאה אי-התאמה בין פעילות העסק המבוקשת
        לבין היתר הבנייה או התב"ע, החוק אינו מאפשר הנפקת
        רישיון באופן אוטומטי.
      </p>

      <p style={styles.warningText}>
        בהתאם לרפורמה של תיקון 101 לחוק התכנון והבנייה,
        בעל העסק נדרש לפעול להסדרת חריגות אלו באופן דיגיטלי.
        על בעל העסק להגיש בקשה רשמית לקבלת היתר לשימוש חורג
        באמצעות המערכת הארצית המקוונת של מנהל התכנון.
      </p>

    </div>

  </div>


  {/* זמן קבלת היתר */}
  <div style={styles.articleBlock}>

    <h3 style={styles.articleSectionTitle}>
      כמה זמן לוקח לקבל היתר לשימוש חורג?
    </h3>

    <p style={styles.articleText}>
      תהליך קבלת ההיתר דורש סבלנות רבה, ומשך הזמן הממוצע נע
      לרוב בין <strong>6 ל־12 חודשים</strong>, בהתאם למורכבות
      הבקשה ולעומס בוועדה המקומית.
    </p>

    <div style={styles.steps}>

      <div style={styles.step}>
        <span style={styles.stepNumber}>1</span>
        <div>
          <strong style={styles.stepTitle}>
            הכנת תוכניות
          </strong>
          <p style={styles.stepText}>
            הכנת תוכניות על ידי אדריכל מוסמך.
          </p>
        </div>
      </div>

      <div style={styles.step}>
        <span style={styles.stepNumber}>2</span>
        <div>
          <strong style={styles.stepTitle}>
            פרסום הבקשה
          </strong>
          <p style={styles.stepText}>
            פרסום הבקשה ומתן אפשרות להתנגדויות הציבור והשכנים,
            בהתאם להוראות החוק.
          </p>
        </div>
      </div>

      <div style={styles.step}>
        <span style={styles.stepNumber}>3</span>
        <div>
          <strong style={styles.stepTitle}>
            דיון בוועדה
          </strong>
          <p style={styles.stepText}>
            דיון בוועדה המקומית לתכנון ובנייה וקבלת החלטה.
          </p>
        </div>
      </div>

    </div>

  </div>


  {/* סיכונים */}
  <div style={styles.dangerSection}>

    <h3 style={styles.dangerTitle}>
      סיכונים וסנקציות: מה קורה אם פועלים ללא היתר תואם?
    </h3>

    <p style={styles.articleText}>
      הפעלת עסק בסטייה מהיתר הבנייה או מהתב"ע ללא אישור
      לשימוש חורג עלולה להוביל להליכי אכיפה ולסנקציות
      בהתאם לחוק התכנון והבנייה.
    </p>

    <div style={styles.dangerList}>

      <div style={styles.dangerItem}>
        <span>●</span>
        <div>
          <strong>קנסות כספיים</strong>
          <p>
            קנסות מנהליים וקנסות נוספים בהתאם להוראות הדין.
          </p>
        </div>
      </div>

      <div style={styles.dangerItem}>
        <span>●</span>
        <div>
          <strong>צווים משפטיים ומינהליים</strong>
          <p>
            הליכי אכיפה העלולים לכלול צווים להפסקת פעילות
            והליכים משפטיים.
          </p>
        </div>
      </div>

      <div style={styles.dangerItem}>
        <span>●</span>
        <div>
          <strong>פגיעה בהליך רישוי העסק</strong>
          <p>
            אי-הסדרת השימוש עלולה למנוע את קבלת רישיון העסק
            או היתר זמני.
          </p>
        </div>
      </div>

    </div>

  </div>


  {/* רישוי זמין */}
  <div style={styles.systemBox}>

    <div style={styles.systemHeader}>

      <div style={styles.systemIcon}>
        💻
      </div>

      <div>
        <h3 style={styles.systemTitle}>
          מדריך קצר: הגשת בקשה במערכת "רישוי זמין"
        </h3>

        <p style={styles.systemSubtitle}>
          שלבי התהליך להסדרת הבקשה באופן מקוון
        </p>
      </div>

    </div>


    <div style={styles.systemSteps}>

      <div style={styles.systemStep}>

        <span style={styles.systemNumber}>
          01
        </span>

        <div>
          <strong>
            הזדהות ממשלתית
          </strong>

          <p>
            כניסה למערכת הרלוונטית באמצעות מערכת ההזדהות
            הלאומית.
          </p>
        </div>

      </div>


      <div style={styles.systemStep}>

        <span style={styles.systemNumber}>
          02
        </span>

        <div>
          <strong>
            מינוי עורך בקשה
          </strong>

          <p>
            יש להסמיך במערכת עורך בקשה מורשה, כגון אדריכל,
            מהנדס או הנדסאי בניין רשום, אשר ינהל ויגיש
            את התיק בפועל.
          </p>
        </div>

      </div>


      <div style={styles.systemStep}>

        <span style={styles.systemNumber}>
          03
        </span>

        <div>
          <strong>
            קליטת ובחינת התיק
          </strong>

          <p>
            עורך הבקשה יעלה את המדידות, התוכניות ההנדסיות
            והנימוקים התכנוניים, והתיק ינותב לגורם הרלוונטי
            ברשות המקומית.
          </p>
        </div>

      </div>

    </div>

  </div>


  {/* סיכום */}
  <div style={styles.bottomSummary}>

    <span style={styles.summaryIcon}>
      ✓
    </span>

    <p>
      <strong>
        חשוב:
      </strong>
      {' '}
      מומלץ לבדוק את מצב הנכס וההתאמה התכנונית שלו
      כבר בתחילת תהליך פתיחת העסק, כדי לזהות מראש
      בעיות שעלולות לעכב את קבלת הרישיון.
    </p>

  </div>

</div>







          {/* תיבת התראה לתיקון 101 */}
          <div style={styles.warningBox}>
            <span style={styles.warningTitle}>חשוב לדעת:</span>
            <p style={styles.warningText}>
              על פי <strong>תיקון 101</strong>, בעל העסק נדרש להגיש בקשה לקבלת היתר לשימוש חורג 
              באמצעות המערכת הארצית של "רישוי זמין".
            </p>
          </div>

        </div>
      </LightSpeed>
    </div>


  
  </Container>




)
const styles = {
  /* =========================
     CONTAINER
  ========================= */

  container: {
    direction: 'rtl',
    width: '100%',
    boxSizing: 'border-box',
    padding: '30px 15px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: '#f8fbfd',
    overflowX: 'hidden',
  },

  card: {
    width: '100%',
    maxWidth: '900px',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 10px 35px rgba(0,0,0,0.07)',
    border: '1px solid #e2e8f0',
    boxSizing: 'border-box',
    overflow: 'hidden',
    direction: 'rtl',
  },

  /* =========================
     INTRO
  ========================= */

  introText: {
    width: '100%',
    boxSizing: 'border-box',
    fontSize: 'clamp(1rem, 2.5vw, 1.15rem)',
    color: '#2d3748',
    lineHeight: '1.8',
    marginBottom: '30px',
    fontWeight: '500',
    textAlign: 'center',
  },

  listContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '30px',
  },

  listItem: {
    position: 'relative',
    width: '100%',
    minHeight: '70px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f7fafc',
    padding: '18px 65px 18px 18px',
    borderRadius: '12px',
    border: '1px solid #edf2f7',
    direction: 'rtl',
  },

  listIcon: {
    position: 'absolute',
    right: '18px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '28px',
    height: '28px',
    flexShrink: 0,
  },

  listText: {
    width: '100%',
    margin: 0,
    fontSize: 'clamp(0.9rem, 2.3vw, 1.05rem)',
    color: '#4a5568',
    lineHeight: '1.7',
    textAlign: 'center',
    overflowWrap: 'break-word',
    wordBreak: 'normal',
  },

  secondaryText: {
    width: '100%',
    fontSize: 'clamp(0.85rem, 2.2vw, 0.95rem)',
    color: '#718096',
    fontStyle: 'italic',
    marginBottom: '35px',
    lineHeight: '1.7',
    textAlign: 'center',
  },

  /* =========================
     ARTICLE
  ========================= */

  articleSection: {
    width: '100%',
    marginTop: '35px',
    textAlign: 'center',
  },

  articleTitle: {
    width: '100%',
    color: '#263238',
    fontSize: 'clamp(1.35rem, 4vw, 1.7rem)',
    fontWeight: '800',
    lineHeight: '1.5',
    margin: '0 0 8px',
    textAlign: 'center',
  },

  articleIntro: {
    width: '100%',
    color: '#2980b9',
    fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
    fontWeight: '600',
    margin: '0 0 20px',
    lineHeight: '1.7',
    textAlign: 'center',
  },

  articleText: {
    width: '100%',
    color: '#546e7a',
    fontSize: 'clamp(0.9rem, 2.4vw, 1rem)',
    lineHeight: '1.9',
    margin: '0 0 18px',
    textAlign: 'center',
  },

  articleBlock: {
    width: '100%',
    marginTop: '35px',
    paddingTop: '28px',
    borderTop: '1px solid #e5ebef',
    boxSizing: 'border-box',
  },

  articleSectionTitle: {
    width: '100%',
    color: '#263238',
    fontSize: 'clamp(1.15rem, 3.5vw, 1.35rem)',
    fontWeight: '700',
    margin: '0 0 22px',
    lineHeight: '1.5',
    textAlign: 'center',
  },

  /* =========================
     ARTICLE CARDS
  ========================= */

  articleCards: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },

  articleCard: {
    position: 'relative',
    width: '100%',
    minHeight: '110px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '25px 75px 25px 25px',
    backgroundColor: '#ffffff',
    border: '1px solid #e3eaf0',
    borderRadius: '13px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.035)',
    direction: 'rtl',
    textAlign: 'center',
  },

  articleCardNumber: {
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '42px',
    height: '42px',
    minWidth: '42px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '700',
    fontSize: '0.85rem',
    flexShrink: 0,
  },

  articleCardContent: {
    width: '100%',
    maxWidth: '700px',
    textAlign: 'center',
  },

  articleCardTitle: {
    width: '100%',
    color: '#2980b9',
    fontSize: 'clamp(0.95rem, 2.5vw, 1.08rem)',
    margin: '0 0 8px',
    fontWeight: '700',
    textAlign: 'center',
    lineHeight: '1.5',
  },

  articleCardText: {
    width: '100%',
    color: '#607d8b',
    fontSize: 'clamp(0.85rem, 2.3vw, 0.95rem)',
    lineHeight: '1.75',
    margin: 0,
    textAlign: 'center',
    overflowWrap: 'break-word',
  },

  exampleBox: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '12px',
    padding: '10px 13px',
    backgroundColor: '#f5f9fc',
    borderRadius: '8px',
    color: '#607d8b',
    fontSize: 'clamp(0.82rem, 2.2vw, 0.9rem)',
    lineHeight: '1.6',
    borderRight: '3px solid #3498db',
    textAlign: 'center',
  },

  /* =========================
     WARNING
  ========================= */

  warningBox: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '30px',
    padding: '23px 70px 23px 23px',
    background: 'linear-gradient(135deg, #fff8e1, #fffdf5)',
    border: '1px solid #f1d58a',
    borderRadius: '14px',
    direction: 'rtl',
    textAlign: 'center',
  },

  warningIcon: {
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '42px',
    height: '42px',
    minWidth: '42px',
    borderRadius: '50%',
    backgroundColor: '#f1c40f',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '800',
    fontSize: '21px',
    flexShrink: 0,
  },

  warningContent: {
    width: '100%',
    textAlign: 'center',
  },

  warningTitle: {
    margin: '0 0 10px',
    color: '#9a7610',
    fontSize: 'clamp(1rem, 2.8vw, 1.15rem)',
    fontWeight: '700',
    textAlign: 'center',
  },

  warningText: {
    color: '#6d5b23',
    fontSize: 'clamp(0.85rem, 2.3vw, 0.95rem)',
    lineHeight: '1.8',
    margin: 0,
    textAlign: 'center',
  },

  /* =========================
     PROCESS / STEPS
  ========================= */

  steps: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    marginTop: '20px',
  },

  step: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '90px',
    boxSizing: 'border-box',
    padding: '20px 75px 20px 20px',
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    border: '1px solid #e3eaf0',
    boxShadow: '0 4px 14px rgba(0,0,0,0.04)',
    direction: 'rtl',
    textAlign: 'center',
  },

  stepNumber: {
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '42px',
    height: '42px',
    minWidth: '42px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '700',
    fontSize: '1rem',
    flexShrink: 0,
  },

  stepContent: {
    width: '100%',
    maxWidth: '700px',
    textAlign: 'center',
  },

  stepTitle: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    color: '#2980b9',
    fontSize: 'clamp(0.95rem, 2.6vw, 1.1rem)',
    fontWeight: '700',
    margin: '0 0 6px',
    lineHeight: '1.5',
  },

  stepText: {
    width: '100%',
    margin: 0,
    textAlign: 'center',
    color: '#607d8b',
    fontSize: 'clamp(0.85rem, 2.3vw, 0.95rem)',
    lineHeight: '1.8',
  },

  /* =========================
     DANGER
  ========================= */

  dangerSection: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '35px',
    padding: '25px',
    borderRadius: '14px',
    backgroundColor: '#fff7f7',
    border: '1px solid #f1dada',
    borderRight: '5px solid #e74c3c',
    textAlign: 'center',
  },

  dangerTitle: {
    color: '#c0392b',
    fontSize: 'clamp(1.05rem, 3vw, 1.25rem)',
    fontWeight: '700',
    margin: '0 0 15px',
    textAlign: 'center',
  },

  dangerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  dangerItem: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    justifyContent: 'center',
    color: '#c0392b',
    direction: 'rtl',
    textAlign: 'center',
  },

  dangerItemText: {
    margin: 0,
    color: '#607d8b',
    lineHeight: '1.7',
    fontSize: 'clamp(0.85rem, 2.3vw, 0.95rem)',
    textAlign: 'center',
  },

  /* =========================
     RISHUI ZAMIN
  ========================= */

  systemBox: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '35px',
    padding: '28px',
    borderRadius: '15px',
    backgroundColor: '#f5f9fc',
    border: '1px solid #dce8ef',
    textAlign: 'center',
  },

  systemHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '25px',
    direction: 'rtl',
    textAlign: 'center',
  },

  systemIcon: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    flexShrink: 0,
  },

  systemTitle: {
    margin: 0,
    color: '#263238',
    fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
    fontWeight: '700',
    textAlign: 'center',
  },

  systemSubtitle: {
    margin: '5px 0 0',
    color: '#78909c',
    fontSize: 'clamp(0.82rem, 2.2vw, 0.9rem)',
    textAlign: 'center',
  },

  systemSteps: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },

  systemStep: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70px',
    padding: '15px 60px 15px 15px',
    color: '#546e7a',
    direction: 'rtl',
    textAlign: 'center',
    boxSizing: 'border-box',
  },

  systemNumber: {
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '40px',
    height: '40px',
    minWidth: '40px',
    borderRadius: '9px',
    backgroundColor: '#ffffff',
    color: '#2980b9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '700',
    border: '1px solid #dce8ef',
    flexShrink: 0,
  },

  systemStepContent: {
    width: '100%',
    textAlign: 'center',
  },

  systemStepTitle: {
    color: '#2980b9',
    fontWeight: '700',
    fontSize: 'clamp(0.9rem, 2.4vw, 1rem)',
    display: 'block',
    textAlign: 'center',
  },

  systemStepText: {
    margin: '5px 0 0',
    color: '#607d8b',
    lineHeight: '1.7',
    fontSize: 'clamp(0.84rem, 2.2vw, 0.95rem)',
    textAlign: 'center',
  },

  /* =========================
     FINAL SECTION
  ========================= */

  finalSection: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '40px',
    padding: '30px',
    borderRadius: '18px',
    background: 'linear-gradient(135deg, #f8fbff, #eef8f4)',
    border: '1px solid #dce9ef',
    boxShadow: '0 6px 20px rgba(0,0,0,0.04)',
    textAlign: 'center',
  },

  finalHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '28px',
    direction: 'rtl',
    textAlign: 'center',
  },

  finalIcon: {
    width: '48px',
    height: '48px',
    minWidth: '48px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    fontWeight: 'bold',
    boxShadow: '0 5px 12px rgba(52,152,219,0.2)',
  },

  finalTitle: {
    margin: 0,
    color: '#263238',
    fontSize: 'clamp(1.1rem, 3vw, 1.35rem)',
    fontWeight: '800',
    textAlign: 'center',
  },

  finalSubtitle: {
    margin: '5px 0 0',
    color: '#78909c',
    fontSize: 'clamp(0.82rem, 2.2vw, 0.92rem)',
    textAlign: 'center',
  },

  finalGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },

  finalItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '70px',
    padding: '17px 65px 17px 17px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e5edf2',
    direction: 'rtl',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  finalNumber: {
    position: 'absolute',
    right: '17px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '38px',
    height: '38px',
    minWidth: '38px',
    borderRadius: '10px',
    backgroundColor: '#eaf4fb',
    color: '#2980b9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: '800',
    flexShrink: 0,
  },

  finalItemContent: {
    width: '100%',
    textAlign: 'center',
  },

  finalItemTitle: {
    color: '#2980b9',
    fontSize: 'clamp(0.9rem, 2.4vw, 1rem)',
    fontWeight: '700',
    display: 'block',
    textAlign: 'center',
    lineHeight: '1.5',
  },

  finalItemText: {
    margin: '5px 0 0',
    color: '#607d8b',
    fontSize: 'clamp(0.82rem, 2.2vw, 0.92rem)',
    lineHeight: '1.7',
    textAlign: 'center',
  },

  /* =========================
     FINAL TIP
  ========================= */

  finalTip: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '22px',
    padding: '18px 55px 18px 18px',
    backgroundColor: '#fff8e1',
    borderRadius: '12px',
    borderRight: '4px solid #f1c40f',
    color: '#6d5b23',
    direction: 'rtl',
    textAlign: 'center',
  },

  tipIcon: {
    position: 'absolute',
    right: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '21px',
    flexShrink: 0,
  },

  finalTipText: {
    width: '100%',
    margin: 0,
    lineHeight: '1.8',
    fontSize: 'clamp(0.84rem, 2.2vw, 0.95rem)',
    textAlign: 'center',
  },

  /* =========================
     BOTTOM SUMMARY
  ========================= */

  bottomSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '13px',
    marginTop: '30px',
    padding: '18px',
    borderRadius: '12px',
    backgroundColor: '#eaf7ef',
    color: '#356b4a',
    textAlign: 'center',
    direction: 'rtl',
    boxSizing: 'border-box',
  },

  summaryIcon: {
    width: '35px',
    height: '35px',
    minWidth: '35px',
    borderRadius: '50%',
    backgroundColor: '#2ecc71',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    flexShrink: 0,
  },
};